<template>
    <div class="mainBox configBox accList">
        <div class="mainLeft configTab">
            <div class="title">部门管理</div>
            <el-tree
                :key="left_key"
                ref="selectTree"
                class="accountSelectTree"
                v-if="leftDataList.length"
                :data="leftDataList"
                default-expand-all
                :current-node-key="left_id"
                :expand-on-click-node="false"
                node-key="id"
                highlight-current
                @node-click="treeClick"
                :props="{
                    label: 'title',
                    value: 'id',
                    children: 'childrenData',
                }"
            >
                <span
                    class="custom-tree-node"
                    slot-scope="{ node, data }"
                    :class="data.id == left_id ? 'active' : ''"
                >
                    <span>{{ node.label }}</span>
                    <span @click.stop="rightClick($event, data)">
                        <i style="color:#ccc" class="el-icon-more"></i>
                    </span>
                </span>
            </el-tree>

            <el-empty description="暂无角色" v-else>
                <el-button type="primary" size="mini" @click="leftDialog = true"
                    >添加</el-button
                >
            </el-empty>
            <li
                class="onTree"
                v-if="leftDataList.length"
                @click="
                    () => {
                        leftDialog = true
                        isShow = false
                    }
                "
            >
                添加
            </li>
            <contextMenu ref="context-menu"></contextMenu>
        </div>
        <div
            style="transform: translateY(5px)"
            @click="synchronization"
            class="fixed"
            v-if="$store.state.app.myStoreCur.is_corp != 1"
        >
            <el-button type="primary" size="small">同步</el-button>
        </div>
        <!-- 右侧员工表格 -->
        <div class="mainRight configList">
            <div class="tableTop">
                <div class="operationButton">
                    <el-button
                        type="primary"
                        size="small"
                        @click="advertiseUpdate()"
                        v-if="
                            leftDataList.length &&
                                $store.state.app.myStoreCur.is_corp == 1
                        "
                        >添加员工</el-button
                    >
                    <el-button type="primary" size="small" @click="initialPass"
                        >初始密码</el-button
                    >
                </div>
            </div>
            <el-table
                :data="rightRequestData"
                border
                ref="tableRef"
                stripe
                row-key="id"
                v-loading="isLoading"
                @select="select"
                @select-all="select_all"
                @selection-change="selection_change"
            >
                <el-table-column
                    width="55"
                    type="selection"
                    align="center"
                    :reserve-selection="true"
                ></el-table-column>
                <el-table-column prop="uid" v-if="false"></el-table-column>
                <el-table-column
                    align="center"
                    prop="username"
                    label="姓名"
                ></el-table-column>
                <el-table-column align="center" prop="role_name" label="职位">
                    <div slot-scope="scope">
                        {{
                            scope.row.is_leader == 1
                                ? '管理员'
                                : scope.row.role_name
                        }}
                    </div>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="department_name"
                    label="部门名称"
                ></el-table-column>
                <el-table-column label="操作" width="150" align="center">
                    <div slot-scope="scope" class="operation">
                        <div class="view" @click="advertiseUpdate(scope.row)">
                            更新
                        </div>

                        <div
                            class="danger"
                            @click="advertiseDelete(scope.row)"
                            :class="scope.row.is_leader == 1 ? 'leader' : ''"
                        >
                            删除
                        </div>
                    </div>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="tablePage">
                <el-pagination
                    hide-on-single-page
                    background
                    @size-change="sizePage"
                    :current-page.sync="search.page"
                    :page-size="search.limit"
                    :total="search.total"
                    :page-sizes="[15, 20, 25]"
                    layout="total, sizes, prev, pager, next"
                ></el-pagination>
            </div>
        </div>
        <!-- 部门信息修改 -->
        <el-dialog
            title="部门管理"
            custom-class="listDialog"
            width="400px"
            :visible.sync="leftDialog"
            @close="off()"
        >
            <el-form
                :model="leftRequestData"
                ref="leftTabForm"
                class="listForm"
                label-width="80px"
            >
                <el-form-item label="上级部门" prop="parent_id">
                    <el-input
                        v-model="parents"
                        disabled
                        v-if="!leftRequestData.parent_id"
                    ></el-input>
                    <treeSelect
                        :value="Number(leftRequestData.parent_id)"
                        @callBackSelect="callBackSelect"
                        :options="option"
                        :disabled="isShow"
                        :key="keys"
                        v-else
                    ></treeSelect>
                </el-form-item>
                <el-form-item label="部门名称" prop="title">
                    <el-input v-model="leftRequestData.title"></el-input>
                </el-form-item>
                <el-form-item label="排序" prop="sort">
                    <el-input-number
                        v-model="leftRequestData.sort"
                        controls-position="right"
                        :min="0"
                    ></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    size="small"
                    @click="submitForm('leftTabForm')"
                    >确 定</el-button
                >
            </div>
        </el-dialog>
        <!-- 员工信息修改 -->
        <el-dialog
            title="员工管理"
            custom-class="listDialog"
            width="400px"
            :visible.sync="rightDialog"
            @close="
                () => {
                    $refs.rightTabForm.resetFields(),
                        (rightDateList.is_leader = 2)
                }
            "
        >
            <el-form
                :model="rightDateList"
                ref="rightTabForm"
                class="listForm"
                label-width="80px"
            >
                <el-form-item label="部门" prop="department_id">
                    <treeSelect
                        :value="+rightDateList.department_id"
                        @callBackSelect="callBackSelects"
                        :options="option"
                        :disabled="false"
                        v-if="!rightDateList.length"
                    ></treeSelect>
                    <el-button
                        v-else
                        type="primary"
                        size="mini"
                        @click="
                            leftDialog = true
                            rightDialog = false
                        "
                        >去管理</el-button
                    >
                </el-form-item>
                <el-form-item
                    label="角色名称"
                    prop="admin_rid"
                    :rules="[{ required: true, message: '请选择' }]"
                >
                    <el-input
                        disabled
                        v-model="leader"
                        v-if="rightDateList.is_leader == 1 ? true : false"
                    ></el-input>
                    <el-select
                        v-model="rightDateList.admin_rid"
                        placeholder="请选择"
                        v-else
                    >
                        <el-option
                            v-for="item in roleInfo"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    label="用户名"
                    prop="username"
                    :rules="[{ required: true, message: '请输入用户名' }]"
                >
                    <el-input v-model="rightDateList.username"></el-input>
                </el-form-item>
                <el-form-item
                    label="联系方式"
                    prop="phone"
                    :rules="[{ required: true, message: '请输入联系方式' }]"
                >
                    <el-input v-model="rightDateList.phone"></el-input>
                </el-form-item>
                <el-form-item
                    label="是否禁用"
                    prop="is_disable"
                    :rules="[{ required: true, message: '请选择' }]"
                >
                    <el-radio :label="1" v-model="rightDateList.is_disable"
                        >正常</el-radio
                    >
                    <el-radio :label="2" v-model="rightDateList.is_disable"
                        >禁用</el-radio
                    >
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    size="small"
                    @click="submitForm('rightTabForm')"
                    >确 定</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script>
import contextMenu from '@/components/contextMenu/index.vue'
import treeSelect from '@/components/treeSelect/index.vue'
export default {
    components: { contextMenu, treeSelect },
    data() {
        return {
            left_key: 1,
            parents: '顶级',
            leader: '管理员',
            keys: 0,
            isShow: false,
            option: [],
            isLoading: false,
            rightRequestData: [], //表格数据
            leftRequestData: {
                childrenData: [], //子集
                id: '',
                title: '', //部门名称
                parent_id: -1, //上级ID
                sort: '', //排序
            },
            left_id: 0,
            leftDialog: false,
            leftDataList: [],
            search: {
                total: 0,
                page: 1,
                limit: 15,
            },
            rightDialog: false,
            rightDateList: {
                uid: '',
                username: '',
                phone: '',
                admin_rid: '',
                department_id: -1,
                is_disable: 1,
                is_leader: 2,
            },
            roleInfo: [],
            oriCurId: 0,
            columns: {},
            checkList: [],
            flag: 0,
        }
    },
    watch: {
        left_key(newval, oldval) {
            if (newval == 100) this.left_key = 1
        },
        keys(newval, oldval) {
            if (newval == 100) this.keys = 1
        },
        //监听左侧分类数据变化
        left_id() {
            this.getAccountList(true)
        },
        // 配置列表分页
        'search.page'() {
            this.getAdvertiseList()
        },
        'search.limit'() {
            this.getAdvertiseList()
        },
    },
    mounted() {
        this.getDepartmentLists()
    },
    methods: {
        append($event, data) {
            console.log($event)
        },
        async initialPass() {
            if (!this.checkList.length)
                return this.$commonFun.toast('请先选择员工', 'error')
            await this.$api.initialPassword({ uid: [...this.checkList] })
            this.$refs.tableRef.clearSelection()
            this.checkList = []
            this.flag = 0
            this.$commonFun.toast('操作成功', 'success')
        },
        select(val, item) {
            if (this.checkList.indexOf(item.uid) == -1) {
                this.checkList.push(item.uid)
            } else {
                let index = this.checkList.findIndex((res) => res == item.uid)
                this.checkList.splice(index, 1)
            }
        },
        selection_change(val) {
            if (val.length == this.rightRequestData.length) {
                this.$nextTick(() => {
                    this.flag = 1
                })
            }
            if (val.length == 0 || val.length < this.rightRequestData.length) {
                this.$nextTick(() => {
                    this.flag = 0
                })
            }
        },
        select_all(val) {
            if (this.flag) {
                this.checkList = []
                this.flag = 0
                return
            }
            this.flag++
            let checkAll = val.map((res) => res.uid)
            if (!this.checkList.length) {
                this.checkList.push(...checkAll)
                return
            }
            checkAll.forEach((row) => {
                let index = this.checkList.findIndex(
                    (element) => element == row
                )
                if (index == -1) this.checkList.push(row)
            })
        },

        // -----------------------------
        async synchronization() {
            this.isLoading = true
            await this.$api.synchroDepartment()
            await this.$api.synchroStaff()
            this.isLoading = false
            this.getDepartmentLists()
            this.getAccountList()
            this.$commonFun.toast('同步成功', 'success')
        },
        sizePage(val) {
            this.search.limit = val
        },
        off() {
            this.$refs.leftTabForm.resetFields()
            this.leftRequestData.id = ''
        },
        treeClick(item) {
            this.left_id = item.id
        },
        callBackSelect(e) {
            this.leftRequestData.parent_id = e
        },
        callBackSelects(e) {
            this.rightDateList.department_id = e
        },
        //左侧右击事件
        rightClick(e, column, node) {
            this.oriCurId = column.id
            this.columns = column
            var el = e.currentTarget
            if (column.id) {
                this.isShow = true
            }

            let _self = this

            if (column.id) {
                let id = column.id
                let list = [
                    {
                        label: '编辑',
                        icon: 'el-icon-edit',
                        callback(item, done) {
                            done()
                            // _self.isShow = false
                            _self.leftDialog = true
                            _self.$nextTick(() => {
                                _self.leftRequestData = {
                                    ...column,
                                }
                            })
                        },
                    },
                    {
                        label: '删除',
                        icon: 'el-icon-delete',
                        callback(item, done) {
                            done()
                            _self
                                .$confirm(
                                    '确定删除该分类？此操作不可逆！',
                                    '提示'
                                )
                                .then((result) => {
                                    _self.$api
                                        .getDepartmentDel({
                                            id: id,
                                        })
                                        .then((res) => {
                                            _self.$refs.selectTree.remove(
                                                column
                                            )
                                            _self.$commonFun.toast(
                                                '删除成功',
                                                'success'
                                            )
                                            _self.getDepartmentLists(true)
                                            if (
                                                id == _self.left_id &&
                                                _self.leftDataList.length
                                            ) {
                                                _self.left_id =
                                                    _self.leftDataList[0].id
                                            }
                                        })
                                })
                        },
                    },
                ]
                this.$refs['context-menu'].open(e, list)
            }
        },

        //角色列表
        getDepartmentLists(refash) {
            this.$api.getDepartmentList().then((res) => {
                if (refash) return (this.option = res)
                if (res.length) {
                    this.leftDataList = res
                    this.left_id = res[0].id
                    this.option = res
                }
            })
        },
        //员工列表
        getAccountList(refresh) {
            this.isLoading = true
            if (refresh) {
                this.search.page = 1
            }
            let param = { department_id: this.left_id, ...this.search }
            this.$api.accountList(param).then((res) => {
                this.isLoading = false
                ;(this.rightRequestData = res.data),
                    (this.search.total = res.count)
            })
        },
        //表单提交
        submitForm(formName) {
            let _self = this
            _self.$commonFun.debounce(() => {
                _self.$refs[formName].validate(async (valid) => {
                    if (!valid) return
                    if (valid) {
                        if (formName == 'leftTabForm') {
                            //广告位信息更新
                            let param = JSON.parse(
                                JSON.stringify(_self.leftRequestData)
                            )
                            if (param.parent_id == -1) param.parent_id = 0
                            _self.$api
                                .getDepartmentUpdate(param)
                                .then((res) => {
                                    res.id = +res.id
                                    res.parent_id = +res.parent_id
                                    if (param.id) {
                                        //信息更新
                                        _self.$set(
                                            _self.columns,
                                            'title',
                                            res.title
                                        )
                                    } else if (!param.parent_id) {
                                        //分类添加
                                        if (_self.leftDataList.length == 1) {
                                            _self.left_id = res.id
                                        }
                                        _self.leftDataList.push(res)
                                        _self.keys += 1
                                    } else {
                                        console.log(res)
                                        _self.$nextTick(() => {
                                            console.log(param, 'id')
                                            _self.$refs.selectTree.append(
                                                res,
                                                param.parent_id
                                            )
                                        })
                                        _self.keys += 1
                                    }
                                    _self.$commonFun.toast('SUCCESS', 'success')
                                    _self.leftDialog = false
                                    _self.getDepartmentLists(true)
                                })
                        }
                        if (formName == 'rightTabForm') {
                            let param = { ..._self.rightDateList }
                            const res = await _self.$api.accountUpdate(param)
                            _self.$commonFun.toast('SUCCESS', 'success')
                            _self.rightDialog = false
                            _self.left_id = param.department_id
                            _self.left_key += 1
                            _self.getAccountList()
                        }
                    }
                })
            })
        },
        //员工删除
        advertiseDelete(row) {
            if (row.is_leader == 1)
                return this.$commonFun.toast('该角色不可操作', 'warning')
            let _self = this
            let pageCount = Math.ceil(
                (this.search.total + this.search.limit - 1) / this.search.limit
            )
            _self
                .$confirm('确定删除该信息？此操作不可逆！', '提示')
                .then((result) => {
                    _self.$api
                        .accountDel({
                            uid: row.uid,
                        })
                        .then((res) => {
                            _self.$commonFun.toast('删除成功', 'success')
                            // 最后一页没有数据了，直接向前进1
                            if (
                                _self.rightRequestData.length == 1 &&
                                _self.search.page !== 1 &&
                                pageCount == _self.search.page
                            ) {
                                _self.search.page--
                            } else {
                                _self.getAccountList()
                            }
                        })
                })
        },
        //员工信息回显
        async advertiseUpdate(row) {
            this.rightDialog = true
            let param = {}
            if (row) param.uid = row.uid
            this.$nextTick(async () => {
                const res = await this.$api.accountInfo(param)
                this.roleInfo = res.roleInfo
                if (row) {
                    res.data.department_id = res.data.department_id || -1
                    this.rightDateList = res.data
                }
            })
        },
    },
}
</script>

<style lang="scss">
.accList {
    position: relative;
}
.accountSelectTree {
    margin-top: 5px;
    max-height: 800px;
    overflow-y: auto;
    position: relative;
    &::-webkit-scrollbar {
        width: 5px;
        height: 1px;
    }
    &::-webkit-scrollbar-thumb {
        background: rgba(0, 21, 41, 0.1);
        border-radius: 30px;
    }
    &::-webkit-scrollbar-track {
        background: #fff;
    }
    .el-tree--highlight-current
        .el-tree-node.is-current
        > .el-tree-node__content {
        background-color: rgb(158, 213, 250) !important;
    }

    .el-tree-node__content {
        height: auto;
        padding: 0 20px;
        line-height: 34px;
        background: none !important;
    }
    .el-tree-node__label {
        font-weight: normal;
    }
    .is-current .el-tree-node__label {
        color: #409eff;
        font-weight: 700;
    }
    .is-current .el-tree-node__children .el-tree-node__label {
        color: #606266;
        font-weight: normal;
    }
}

.onTree {
    color: #2d8cf0;
    cursor: pointer;
    letter-spacing: 1px;
    font-size: 14px;
    margin-left: 20px;
}
.custom-tree-node {
    width: 100%;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
}
.active {
    color: #409eff;
    font-weight: 700;
}
.leader {
    color: #ccc !important;
}
</style>
